import React, { useState } from "react";
import {
  View,
  TextInput,
  TouchableOpacity,
  Image,
  Text,
  StyleSheet,
} from "react-native";
import {
  Flex,
  Padding,
  Margin,
  Helpers,
  Colors,
  FontFamily,
  FontWeight,
  button,
  modalStyle,
  Typo,
  formStyle,
  unlockBox,
} from "../../styles/appStyles";
import CustomImage from "../custom-image";
import getImagePath from "../../utils/image-helper";
const googleIcon = getImagePath("icons/popup-google.png");

const SignupFormTextComponentMobile = (props) => {
  const [email, setEmail] = useState("");

  return (
    <View style={styles.container}>
      <TextInput
        style={props.textInputStyle || styles.textInput}
        placeholder="Enter your email"
        placeholderTextColor={props.textInputStyleTextColor}
        value={email}
        onChangeText={setEmail}
      />
      <View style={styles.buttonContainer}>
        <TouchableOpacity
          style={styles.signupButton}
          onPress={() => props.goToSignUp(email)}
        >
          <Text style={styles.signupButtonText}>Sign me up</Text>
        </TouchableOpacity>
        <Text style={props.orText || styles.orText}>OR</Text>
        <TouchableOpacity
          style={styles.googleButton}
          onPress={props.goToGoogleLoginMobile}
        >
          <CustomImage
            source={googleIcon}
            require={true}
            webStyle={{
              width: 16,
              height: 16,
              marginRight: 6,
              marginLeft: 0,
            }}
            style={{ width: 16, height: 16, marginRight: 6, marginLeft: 0 }}
          />
          <Text style={styles.googleButtonText}>Sign up with Google</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: 14,
  },
  textInput: {
    marginBottom: 20,
    width: "100%",
    borderBottomWidth: 2,
    borderBottomColor: '#051462',
    color: '#051462',
    marginRight: 0,
    paddingTop: 8,
    paddingBottom: 8, 
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 30,
    fontFamily: FontFamily.regular,
    height: 50,
  },
  buttonContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  signupButton: {
    backgroundColor: "#43CEBD",
    width: 90,
    alignItems: 'center',
    flexDirection: "row",
    justifyContent: 'center',
    padding: 6,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },
  signupButtonText: {
    color: '#fafafa',
    fontWeight: 900,
    fontSize: 11,
    lineHeight: 19,
    fontFamily: FontFamily.regular,
    textTransform: 'uppercase',
  },
  orText: {
    color: '#051462',
    padding: 6,
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 19,
    fontFamily: FontFamily.regular,
  },
  googleButtonContainer: {
    flexDirection: "row",
    marginBottom: 40,
  },
  googleButton: {
    backgroundColor: "white",
    width: 140,
    flexDirection: "row",
    display: 'flex',
    alignItems: 'center',
    paddingHorizontal: 6,
    paddingVertical: 6,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },
  googleButtonText: {
    color: "#292929",
    fontWeight: 400,
    fontSize: 11,
    lineHeight: 19,
    fontFamily: FontFamily.regular,
  },
});

export default SignupFormTextComponentMobile;
